import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import { oidcConfig } from "./config/authConfig";
import { LicenseInfo } from "@mui/x-license";
import { ToastContainer } from "react-toastify";

import "./index.css";

LicenseInfo.setLicenseKey(
  "5765a213bc618a7539b7ac9a77a46f67Tz0xMTkyNDMsRT0xNzg5Nzc1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
);

const MemoizedApp = React.memo(App); // <-- Place the memoization here

// 1) Get a reference to the div with ID root
const el = document.getElementById("root");

// 2) Tell React to take control of that element
const root = ReactDOM.createRoot(el);

// 3) Show the component on the screen
root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
          limit={3}
        />
        <MemoizedApp />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
